import initTabs from './tabs';
import initComment from './comment';
import initCount from './count';
import initButtonLike from './button-like' ;
import initFilter from './filter';
import initSelect from './select';
import {profileMessages} from './message-popup';
import initInfoSection from './info-section';
import initSwitches from './switches';
import initUserInfo from './user-info';
import initStatsInfo from './stats-info';
import initUserItem from './user-item';
import initForms from './forms';
import initAuthorCard from './author-card';
import initPopupsGallery from './popup-gallery';
import initUploadPage from './upload-page';
import initCardControls from './card-controls';
import initSpamButton from './spam-button';
import {handleLikeCard} from './card';
import initSidebarAction from './sidebar-action';
import initArticleControls from './article-controls';
import initWelcomeIllustratorPopup from './welcome-illustrator-popup';
import initWelcomeCustomerPopup from './welcome-customer-popup';

import './pagination';
import './awards';
import './tags';
import './list-loader';
import './tooltip';
import './live-comment';
import './share';
import './preloader';
import './checkbox';
import './status';
import './wiziwig-lookup';
import './tags-list';
import './post-item';
import './social-checkbox';
import './access-lock-popup';
import './cropper';
import './bubble-error';
import './upload-massage';
import './bubble';
import './banner';
import './form-body';
import './tippy';
import './user-work';
import './sidebar-block';
import './redaction-card';
import './premium-job';
import './job-banner';
import './about-premium';
import './premium-advantage';
import './premium-author';
import './review-slide';
import './portfolio';
import './tariff-plan';

export default () => {
  initSelect();
  initFilter();
  initForms();
  initComment();
  initPopupsGallery();
  initCardControls();
  handleLikeCard();
  $('.tabs').length && initTabs($('.tabs'));
  $('.count').length && initCount();
  $('.button-like').length && initButtonLike();
  $('.info-section').length && initInfoSection();
  profileMessages();
  $('.switches').length && initSwitches();
  $('.user-info').length && initUserInfo();
  $('.stats-info').length && initStatsInfo();
  $('.user-item').length && initUserItem();
  $('.author-card').length && initAuthorCard();
  $('.upload-page').length && initUploadPage();
  initSpamButton();
  $('.comment-form__input').emoji();

  const $sidebarAction = $('.sidebar-action');
  $sidebarAction && initSidebarAction($sidebarAction);

  $(".gallery").length && import('./gallery').then(({ default: initGallery }) => initGallery());

  const $articleControls = $('.article-controls');
  $articleControls.length && initArticleControls($articleControls);

  $('#welcome-illustrator-popup').length && initWelcomeIllustratorPopup()
  $('#welcome-customer-popup').length && initWelcomeCustomerPopup()
}
